import userTranslationsHelper from "../../../../../languages/user-translations.helper";
import { DriverPlanNotAcceptableResponseErrorType } from "../../../../api/raily/driver/plan/accept/driver-plan-accept.response";
import {
  DriverPlanAcceptCandidateFitsWithNotEnoughTimeError,
  DriverPlanAcceptCandidateFitsWithPlanEntryCollisionError,
  DriverPlanAcceptDefaultError,
  DriverPlanAcceptDeleteSolvedOrderTargetNotFoundError,
  DriverPlanAcceptErrorType,
  DriverPlanAcceptNoTaxiDriverAssociationError,
  DriverPlanAcceptNoValidTaxiDriverContractError,
  DriverPlanAcceptNoValidTaxiRailyContractError,
  DriverPlanAcceptPlanENtryCandidateCollisionError,
  DriverPlanAcceptPlanEntryCandidateStartTimeExpiredErrorError,
  DriverPlanAcceptTooManyCheckoutEventsError,
} from "./driver-plan-accept-error";

const createNoTaxiDriverAssociationError =
  (): DriverPlanAcceptNoTaxiDriverAssociationError => {
    const translations =
      userTranslationsHelper.getDriverDetailsCandidatureTranslations()
        .management;

    return {
      message: translations.apiErrors.taxiDriverAssociationNotExistsErrorLabel,
      params: {},
      type: DriverPlanAcceptErrorType.NO_TAXI_DRIVER_ASSOCIATION,
    };
  };

const createNoValidTaxiDriverContractError =
  (): DriverPlanAcceptNoValidTaxiDriverContractError => {
    const translations =
      userTranslationsHelper.getDriverDetailsCandidatureTranslations()
        .management;

    return {
      message: translations.apiErrors.taxiDriverContractNotValidErrorLabel,
      params: {},
      type: DriverPlanAcceptErrorType.NO_VALID_TAXI_DRIVER_CONTRACT,
    };
  };

const createNoValidTaxiRailyContractError =
  (): DriverPlanAcceptNoValidTaxiRailyContractError => {
    const translations =
      userTranslationsHelper.getDriverDetailsCandidatureTranslations()
        .management;

    return {
      message: translations.apiErrors.taxiRailyContractNotValidErrorLabel,
      params: {},
      type: DriverPlanAcceptErrorType.NO_VALID_TAXI_RAILY_CONTRACT,
    };
  };

const createDeleteSolvedOrderTargetNotFoundError =
  (): DriverPlanAcceptDeleteSolvedOrderTargetNotFoundError => {
    const translations =
      userTranslationsHelper.getDriverDetailsCandidatureTranslations()
        .management;

    return {
      message: translations.apiErrors.orderNotExistsErrorLabel,
      params: {},
      type: DriverPlanAcceptErrorType.DELETE_SOLVED_ORDER_TARGET_NOT_FOUND,
    };
  };
const createTooManyCheckoutEventsError =
  (): DriverPlanAcceptTooManyCheckoutEventsError => {
    const translations =
      userTranslationsHelper.getDriverDetailsCandidatureTranslations()
        .management;

    return {
      message: translations.apiErrors.orderInProgressErrorLabel,
      params: {},
      type: DriverPlanAcceptErrorType.TOO_MANY_CHECKOUT_EVENTS,
    };
  };
const createCandidateFitsWithPlanEntryCollision =
  (): DriverPlanAcceptCandidateFitsWithPlanEntryCollisionError => {
    const translations =
      userTranslationsHelper.getDriverDetailsCandidatureTranslations()
        .management;

    return {
      message:
        translations.apiErrors.candidateFitsWithPlanEntryCollisionErrorLabel,
      params: {},
      type: DriverPlanAcceptErrorType.CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION,
    };
  };
const createCandidateFitsWithNotEnoughTime =
  (): DriverPlanAcceptCandidateFitsWithNotEnoughTimeError => {
    const translations =
      userTranslationsHelper.getDriverDetailsCandidatureTranslations()
        .management;

    return {
      message: translations.apiErrors.candidateFitsWithNotEnoughTimeErrorLabel,
      params: {},
      type: DriverPlanAcceptErrorType.CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME,
    };
  };
const createPlanEntryCandidateCollision =
  (): DriverPlanAcceptPlanENtryCandidateCollisionError => {
    const translations =
      userTranslationsHelper.getDriverDetailsCandidatureTranslations()
        .management;

    return {
      message: translations.apiErrors.planEntryCandidateCollisionErrorLabel,
      params: {},
      type: DriverPlanAcceptErrorType.PLAN_ENTRY_CANDIDATE_COLLISION,
    };
  };
const createPlanEntryCandidateStartTimeExpiredError =
  (): DriverPlanAcceptPlanEntryCandidateStartTimeExpiredErrorError => {
    const translations =
      userTranslationsHelper.getDriverDetailsCandidatureTranslations()
        .management;

    return {
      message: translations.apiErrors.planEntryCandidateStartTimeExpiredError,
      params: {},
      type: DriverPlanAcceptErrorType.PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR,
    };
  };

const createDefaultError = (
  responseErrorType: DriverPlanNotAcceptableResponseErrorType,
): DriverPlanAcceptDefaultError => {
  const translations =
    userTranslationsHelper.getDriverDetailsCandidatureTranslations().management;

  return {
    message: translations.failureCandidatureAcceptanceNotificationText,
    params: {
      responseErrorType: responseErrorType,
    },
    type: DriverPlanAcceptErrorType.DEFAULT_ERROR,
  };
};

const driverPlanAcceptErrorFactory = {
  createNoTaxiDriverAssociationError,
  createNoValidTaxiDriverContractError,
  createNoValidTaxiRailyContractError,
  createDeleteSolvedOrderTargetNotFoundError,
  createTooManyCheckoutEventsError,
  createCandidateFitsWithPlanEntryCollision,
  createCandidateFitsWithNotEnoughTime,
  createPlanEntryCandidateCollision,
  createPlanEntryCandidateStartTimeExpiredError,
  createDefaultError,
};

export default driverPlanAcceptErrorFactory;
